// import { createSlice } from '@reduxjs/toolkit';
// import { getVisibleColumns } from '../../../../services/ObjectConfiguration/ObjectConfiguration.service';
import { SortDirection } from '../../../../utils/constants';
import { updateEndDate, updateStartDate } from '../../../../utils/dateTimeUtls';
// import { getStartDateWithTime, getEndDateWithTime } from '../../../../utils/constants/datetime';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

const filterFields = {
  LocationIdentifier: 'LocationIdentifier',
  LocationFormat: 'LocationFormat',
  SampleNumber: 'SampleNumber',
  MaxxID: 'MaxxID',
  ClientIDPetro: 'ClientIDPetro',
  AnalysisType: 'AnalysisType',
  SampleStatus: 'SampleStatus',
  MaxxAlertStatus: 'MaxxAlertStatus',
  ClientReviewStatus: 'ClientReviewStatus',
  clientIDs: 'clientIDs',
  reportAddressIDs: 'reportAddressIDs',
  scenarioIDs: 'scenarioIDs',
  AttentionName: 'AttentionName',
  Area: 'Area',
  SamplePoint: 'SamplePoint',
  JobNumber: 'JobNumber',
  Matrix: 'Matrix',
  ProjectNumber: 'ProjectNumber',
  PONumber: 'PONumber',
  ReceivedDateFrom: 'ReceivedDateFrom',
  ReceivedDateTo: 'ReceivedDateTo',
  SampleDateFrom: 'SampleDateFrom',
  SampleDateTo: 'SampleDateTo',
  // Functionality: 'Functionality',
};

const initialFilterState = {
  LocationIdentifier: null,
  LocationFormat: '',
  SampleNumber: '',
  MaxxID: '',
  ClientIDPetro: '',
  AnalysisType: null,
  SampleStatus: null,
  MaxxAlertStatus: null,
  ClientReviewStatus: null,
  clientIDs: [],
  reportAddressIDs: [],
  scenarioIDs: [],
  AttentionName: '',
  Area: '',
  SamplePoint: '',
  JobNumber: '',
  Matrix: null,
  ProjectNumber: null,
  PONumber: null,
  ReceivedDateFrom: updateStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1))).toISOString(),
  ReceivedDateTo: updateEndDate(new Date()).toISOString(),
  SampleDateFrom: updateStartDate(new Date(new Date().setMonth(new Date().getMonth() - 1))).toISOString(),
  SampleDateTo: updateEndDate(new Date()).toISOString(),

  page: 0,
  pageSize: 20,
  sortColumn: 'SampleNumber',
  sortDirection: SortDirection.Desc,
  Functionality: 'samples'
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'SampleNumber',
  sortDirection: SortDirection.Desc,
};

export const sliceName = 'petrohubSampleSearch';
const petrohubSampleSearchSlice = createSearchPageSlice({
  sliceName,
  filterFields,
  initialFilterState,
  initialPageState
});

export const petrohubSampleSearchActions = petrohubSampleSearchSlice.actions;
export default petrohubSampleSearchSlice.reducer;
